const tags = document.getElementById('article-listing-filter');
const gotToTagURL = (tag) => {
    const blogURL = window.location.pathname.split('/').slice(0, 3).join('/');
    if (tag === '') {
        window.location.pathname = `${blogURL}`;
    }
    else {
        window.location.pathname = `${blogURL}/tagged/${tag}`;
    }
};
if (tags) {
    tags.addEventListener('change', (event) => {
        gotToTagURL(event.target.value);
    });
}
